export const ADDRESSES_TYPES = {
  Billing: "Billing",
  Shipping: "Shipping",
}
